module.exports = __webpack_public_path__ + "img/coupon_tab_apply.7e8ea310.svg";